import React, { FC, ReactNode } from 'react';
import { Badge, Popover, Tooltip } from 'antd';

import { TooltipPlacement } from 'antd/es/tooltip';

import { IPOAvatar, IPOIcon } from '../../index';

import chatIcon from '../../images/components/header/chat.svg';

import accountIcon from '../../images/components/header/account.svg';
import msgIcon from '../../images/components/header/msg.svg';
import helpIcon from '../../images/components/header/help.svg';
import profileIcon from '../../images/components/header/profile.svg';
import existIcon from '../../images/components/header/exist.svg';

import { TUserOpes, IChats, IUserHeaderProps, MsgEnum } from './userHeader';
import { UserHeaderTopWrap, UserHeaderLeftWrap, UserMenuWrap, MsgWrap, UnreadWrap } from './style';

const UserOpes: FC<TUserOpes & { dir?: TooltipPlacement; size?: number }> = props => {
	const getMsgEle: () => ReactNode = () => {
		return (
			<MsgWrap>
				<div className="msg-item" onClick={() => props.handleChangeMsgType(MsgEnum.WX)}>
					微信
				</div>
				<div className="msg-item" onClick={() => props.handleChangeMsgType(MsgEnum.LINE)}>
					line
				</div>
				<div className="msg-item" onClick={() => props.handleChangeMsgType(MsgEnum.WHATSAPP)}>
					WhatsApp
				</div>
			</MsgWrap>
		);
	};

	const getMenusEle: () => ReactNode = () => {
		return (
			<UserMenuWrap>
				<div className="menus">
					<div className="menu-item" onClick={() => props.handleEnterAccount()}>
						<img src={accountIcon} />
						账号设置
					</div>
					{
						false &&
						(
							<div className="menu-item">
								<Popover
									placement="left"
									content={() => getMsgEle()}
									trigger="click"
									getPopupContainer={node => node}>
									<div>
										<img src={msgIcon} />
										消息通知记录
									</div>
								</Popover>
							</div>
						)
					}
					<div className="menu-item" onClick={() => props.handleEnterHelp()}>
						<img src={helpIcon} />
						帮助中心
					</div>
					<div className="menu-item" onClick={() => props.handleEnterProfile()}>
						<img src={profileIcon} />
						个人偏好中心
					</div>
				</div>
				<div className="logout" onClick={() => props.handleExit()}>
					<img src={existIcon} />
					退出
				</div>
			</UserMenuWrap>
		);
	};

	return (
		<div className="nav-item">
			<Popover
				placement={props.dir}
				title={''}
				content={getMenusEle()}
				trigger="click"
				getPopupContainer={node => node}>
				<div>
					<IPOAvatar size={props.size} info={{ ...props.user, baseUrl: props.baseUrl }} />
				</div>
			</Popover>
		</div>
	);
};

const Chat: FC<IChats & { dir?: TooltipPlacement }> = ({
	dir = 'bottomRight',
	unreadMsgs,
	handleGoProject,
	unreadNum,
}) => {
	const getUnreadEle: () => ReactNode = () => {
		return (
			<UnreadWrap>
				<div className="unread-item">
					{unreadMsgs.map((item, index) => {
						if (item.unreadCount !== 0) {
							return (
								<div
									className="group-item"
									key={index}
									onClick={() => {
										handleGoProject && handleGoProject(item.projectId);
									}}>
									<div className="group-item-left">{item.avatar}</div>
									<div className="group-item-right">
										<div className="group-item-right-top">
											<div className="group-item-title-node">
												<div className="group-name">
													<Tooltip title={`${item.groupName}`}>{item.groupName}</Tooltip>
												</div>
												{item.groupWork && (
													<div className="group-work-name">
														（<span>{item.groupWork}</span>）
													</div>
												)}
											</div>
											<div className="group-last-time">{item.lastTime}</div>
										</div>
										<div className="group-item-right-bottom">
											{item.lastId && (
												<div className="message-text">
													<div className="message-sender-name">{item.lastUser}:</div>
													<div className="text">{item.lastMsg}</div>
												</div>
											)}
											<div className="group-item-unread">{item.unreadCount}</div>
										</div>
									</div>
								</div>
							);
						} else return <></>;
					})}
				</div>
			</UnreadWrap>
		);
	};

	return (
		<Popover
			getPopupContainer={node => node}
			className="header-chat"
			placement={dir}
			title={''}
			content={getUnreadEle()}
			trigger="hover">
			<Badge count={unreadNum} size="small" offset={[0, 5]}>
				<div className="nav-item">
					<IPOIcon src={chatIcon} width={29} height={29} isHover={false} />
				</div>
			</Badge>
		</Popover>
	);
};

export const UserHeader: FC<IUserHeaderProps & { showType: 'LEFT' | 'TOP' }> = ({
	showType,
	...props
}) => {
	return (
		<React.Fragment>
			{showType === 'LEFT' && <UserHeaderLeft {...props} />}
			{showType === 'TOP' && <UserHeaderTop {...props} />}
		</React.Fragment>
	);
};

const UserHeaderTop: FC<IUserHeaderProps> = props => {
	return (
		<UserHeaderTopWrap style={props.style}>
			<div className="left">
				<div className="home-title">项目</div>
			</div>
			<div className="right">
				<Chat {...props} />
				<UserOpes {...props} size={20} />
			</div>
		</UserHeaderTopWrap>
	);
};

export const UserHeaderLeft: FC<IUserHeaderProps> = props => {
	return (
		<UserHeaderLeftWrap style={props.style}>
			<UserOpes {...props} size={20} dir="rightBottom" />
			<Chat {...props} dir="rightBottom" />
		</UserHeaderLeftWrap>
	);
};
